import React, { ChangeEventHandler, FC } from "react"

import Icon, { ICON_TYPES } from "@components/Icon/Icon"

import "./FakeSelect.scss"

type FakeSelectProps = {
  className?: string
  iconSize?: string
  value: string | number
  onChange: ChangeEventHandler<HTMLSelectElement>
  options: {
    disabled?: boolean
    name: string
    value: string | number
  }[]
}

const FakeSelect: FC<FakeSelectProps> = ({
  className,
  iconSize = "20px",
  onChange,
  options,
  value,
}) => {
  return (
    <span
      className={`FakeSelect ${className ? className : ""}`}
      style={{ "--FakeSelect--icon-size": iconSize }}
    >
      <span>
        {options.find(o => o.value === value)?.name}
        <Icon
          color="var(--color--action-default)"
          size={iconSize}
          type={ICON_TYPES["chevron-down"]}
        />
      </span>
      <select
        onChange={onChange}
        value={value}
      >
        {options.map(o => (
          <option
            disabled={o.disabled}
            key={o.name}
            value={o.value}
          >
            {o.name}
          </option>
        ))}
      </select>
    </span>
  )
}

export default FakeSelect
